module.exports = __webpack_public_path__ + "static/media/logo_verme_small_dark_color.d8a1eaeb.svg";